import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {Checkbox, Empty, Flex, Input, List, Spin, Typography} from 'antd'
import useDebouncedValue from '../../utils/common_function'
import {getRequest} from '../../services/base'

const { Text } = Typography

const SelectMakeModel = ({ selected, onSelect = () => {} }) => {
  const intl = useIntl()
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebouncedValue(search, 300)
  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchFailed, setSearchFailed] = useState(false)

  const fetchVehicles = async (q = '') => {
    setLoading(true)
    try {
      let res = await getRequest(`/api/vehicles/?search=${q}&limit=50`)
      // Runs on every debounced keystroke, so the failure is shown in the empty
      // placeholder below rather than as a toast.
      if (res?.status === false) {
        setSearchFailed(true)
        setVehicles([])
        return
      }
      setSearchFailed(false)
      setVehicles(res?.results || [])
    } catch {
      setSearchFailed(true)
      setVehicles([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchVehicles(debouncedSearch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch])

  return (
    <Flex vertical gap={12}>
      <Input.Search
        allowClear
        placeholder={intl.formatMessage({ id: 'tracerPreview.searchMakeModel' })}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onSearch={(value) => setSearch(value)}
      />

      <div className="select-make-model-container">
        {loading ? (
          <Flex justify="center" align="center" className="select-make-model-placeholder">
            <Spin size="large" />
          </Flex>
        ) : vehicles.length === 0 ? (
          <Flex justify="center" align="center" className="select-make-model-placeholder">
            <Empty
              description={intl.formatMessage({
                id: searchFailed ? 'generic.searchFailed' : 'tracerPreview.noVehiclesFound',
              })}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          </Flex>
        ) : (
          <div className="select-make-model-list-wrapper">
            <List
              dataSource={vehicles}
              renderItem={(vehicle) => {
                const isSelected = selected?.vehicle_id === vehicle.vehicle_id
                return (
                  <List.Item
                    key={vehicle.vehicle_id}
                    onClick={() => onSelect(isSelected ? null : vehicle)}
                    className={`select-make-model-item${isSelected ? ' selected' : ''}`}
                  >
                    <Flex align="center" gap={12} className="select-make-model-item-content">
                      <Checkbox checked={isSelected} />
                      <Flex vertical className="select-make-model-item-label">
                        <Text strong ellipsis>{vehicle.name}</Text>
                        <Text type="secondary" ellipsis>
                          {vehicle.make_model_id}
                        </Text>
                      </Flex>
                    </Flex>
                  </List.Item>
                )
              }}
            />
          </div>
        )}
      </div>
    </Flex>
  )
}

export default SelectMakeModel
